import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { KeyRound } from 'lucide-react'
import CredentialFormModal from '@/frontend/components/Credentials/CredentialFormModal'

interface Props {
  docUrl: string
}

export default function CredentialStep({ docUrl }: Props) {
  const [modalOpen, setModalOpen] = useState(false)

  const postUrl = `/dashboard/integrations/requests/create_credential?doc_url=${encodeURIComponent(docUrl)}`

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Cadastre as chaves de API ou tokens de acesso da ferramenta. Seu agente vai usá-las para se autenticar.
      </p>
      <Button onClick={() => setModalOpen(true)}>
        <KeyRound className="h-4 w-4" /> Criar credencial
      </Button>

      <CredentialFormModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        postUrl={postUrl}
      />
    </div>
  )
}
